import React from 'react';
import { StyleSheet, View } from 'react-native';
import { rem } from 'design-system/values';
import { SettingsItem } from 'design-system/SettingsItem';
import { IconEdit } from 'design-system/icons';
import { IconRouting } from 'design-system/icons/IconRouting';
import Modal from 'utils/packages/Modal';
import { AccountTypeDisplayLong } from '../constants';
export const ContinueOnboardingModal = {
    show: ({ accountType, onContinue, onStartAgain }) => {
        Modal.show(<View style={styles.content}>
        <SettingsItem icon={<IconRouting gradientKey="skyBlue"/>} title="Continue where you left off" onPress={() => Modal.hide(onContinue)}/>
        <SettingsItem icon={<IconEdit gradientKey="ultimate"/>} title="Start again" onPress={() => Modal.hide(onStartAgain)}/>
      </View>, {
            containerStyle: styles.modal,
            title: `Continue your ${AccountTypeDisplayLong[accountType]} application?`,
        });
    },
};
const styles = StyleSheet.create({
    modal: {
        paddingHorizontal: 0,
        overflow: 'hidden',
    },
    content: {
        paddingVertical: rem(8),
    },
});
